import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from 'recharts';

const ProgressChart = ({ data, type = 'bar', title }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-xs text-muted-foreground">
              <span style={{ color: entry?.color }}>{entry?.name}: </span>
              <span className="font-semibold text-foreground">{entry?.value}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">
        {title}
      </h3>
      <div className="w-full h-64 md:h-80" aria-label={title}>
        <ResponsiveContainer width="100%" height="100%">
          {type === 'bar' ? (
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis 
                dataKey="name" 
                tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
                stroke="var(--color-border)"
              />
              <YAxis 
                tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
                stroke="var(--color-border)"
              />
              <Tooltip content={<CustomTooltip />} />
              <Legend 
                wrapperStyle={{ fontSize: '12px', color: 'var(--color-muted-foreground)' }}
              />
              <Bar dataKey="target" fill="var(--color-muted)" name="Target" radius={[4, 4, 0, 0]} />
              <Bar dataKey="completed" fill="var(--color-primary)" name="Completed" radius={[4, 4, 0, 0]} />
            </BarChart>
          ) : (
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis 
                dataKey="name" 
                tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
                stroke="var(--color-border)"
              />
              <YAxis 
                tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
                stroke="var(--color-border)"
              />
              <Tooltip content={<CustomTooltip />} />
              <Legend 
                wrapperStyle={{ fontSize: '12px', color: 'var(--color-muted-foreground)' }}
              />
              <Line 
                type="monotone" 
                dataKey="survey" 
                stroke="var(--color-primary)" 
                strokeWidth={2}
                name="Survey"
                dot={{ fill: 'var(--color-primary)', r: 4 }}
              />
              <Line 
                type="monotone" 
                dataKey="civil" 
                stroke="var(--color-secondary)" 
                strokeWidth={2}
                name="Civil"
                dot={{ fill: 'var(--color-secondary)', r: 4 }}
              />
              <Line 
                type="monotone" 
                dataKey="technical" 
                stroke="var(--color-accent)" 
                strokeWidth={2}
                name="Technical"
                dot={{ fill: 'var(--color-accent)', r: 4 }}
              />
              <Line 
                type="monotone" 
                dataKey="commission" 
                stroke="var(--color-success)" 
                strokeWidth={2}
                name="Commission"
                dot={{ fill: 'var(--color-success)', r: 4 }}
              />
            </LineChart>
          )}
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ProgressChart;